<template>
  <div class="needs-validation ml-0">
    <div class="col px-0 pr-lg-3" v-if="horseId">
      <section class="bg-white rounded mb-4 p-3 p-sm-4">
        <boy-status-history-table :entity-id="horseId" type="horse" />
      </section>
    </div>

    <section v-else class="col px-0 pr-lg-3">
      <div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>
    </section>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import BoyStatusHistoryTable from '@/components/BoyStatus/BoyStatusHistoryTable'

export default defineComponent({
  name: 'HorseProfileBoyHistory',
  components: { BoyStatusHistoryTable },
  setup(props, { root }) {
    const horseId = computed(() => root.$route.params.slug)

    return { horseId }
  }
})
</script>



// WEBPACK FOOTER //
// src/views/Horses/Profile/HorseProfileBoyHistory.vue